"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PDF = require("../PDF");
var _reactPdf = require("react-pdf");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
var _PDFControlPanel = require("./PDFControlPanel.styled");
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pdf = require("../../utils/pdf");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (0, _pdf.pdfWorkerFactory)();
var PDFControlPanel = function PDFControlPanel(_ref) {
  var onPageClick = _ref.onPageClick,
    pdfSource = _ref.pdfSource,
    activePage = _ref.activePage;
  var _useState = (0, _react.useState)(1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    numPages = _useState2[0],
    setNumPages = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    renderedPageCount = _useState4[0],
    setRenderedPageCount = _useState4[1];
  (0, _react.useEffect)(function () {
    setRenderedPageCount(0);
  }, [pdfSource]);
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numPages = _ref2.numPages;
    setNumPages(numPages);
  };
  var countRenderedPages = function countRenderedPages() {
    setRenderedPageCount(function (renderedPageCount) {
      return renderedPageCount + 1;
    });
  };
  var previewPages = Array.from({
    length: numPages
  }, function (_, i) {
    return i + 1;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.ControlsWrapper, null, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.StyledButton, {
    disabled: activePage <= 1,
    onClick: function onClick() {
      return onPageClick(activePage - 1);
    },
    "data-testid": "pdf-control-panel-prev-btn"
  }, "\u2190 Prev"), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.CurrentTotalPage, null, "".concat(activePage, " / ").concat(numPages)), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.StyledButton, {
    disabled: activePage >= numPages,
    onClick: function onClick() {
      return onPageClick(activePage + 1);
    },
    "data-testid": "pdf-control-panel-next-btn"
  }, "Next \u2192")), renderedPageCount === numPages ? null : /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.PreLoadingPagesWrapper, {
    "data-testid": "pdf-control-panel"
  }, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.ArrowButton, null, "\u2190"), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.PagesWrapper, null, previewPages.map(function (previewPage) {
    return /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.SpinnerWrapper, {
      key: previewPage
    }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, null));
  })), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.ArrowButton, null, "\u2192")), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.Wrapper, {
    isRendered: renderedPageCount === numPages
  }, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.ArrowButton, {
    disabled: activePage <= 1,
    onClick: function onClick() {
      return onPageClick(activePage - 1);
    },
    "data-testid": "pdf-control-panel-arrow-prev-btn"
  }, "\u2190"), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.PagesWrapper, null, previewPages.map(function (previewPage) {
    return /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
      file: pdfSource,
      key: previewPage,
      onLoadSuccess: onDocumentLoadSuccess,
      errorIconSize: "large"
    }, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.PDFPage, {
      isActive: activePage === previewPage
    }, /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFPage, {
      pageNumber: previewPage,
      height: 88,
      onRenderSuccess: countRenderedPages,
      onClick: function onClick() {
        return onPageClick(previewPage);
      }
    })));
  })), /*#__PURE__*/_react["default"].createElement(_PDFControlPanel.ArrowButton, {
    disabled: activePage >= numPages,
    onClick: function onClick() {
      return onPageClick(activePage + 1);
    },
    "data-testid": "pdf-control-panel-arrow-next-btn"
  }, "\u2192")));
};
PDFControlPanel.propTypes = {
  onPageClick: _propTypes["default"].func.isRequired,
  activePage: _propTypes["default"].number.isRequired,
  pdfSource: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = PDFControlPanel;